import React from 'react';
import styled from 'styled-components';
import SiLogin from '../../../pages/user/SiLogin';
import {isMobileOnly} from 'react-device-detect';

const LoginPopupBlock = styled.div` 
width: 100%;
height: 100%;
border-radius: 10px;
`;


export const LoginPopupStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: isMobileOnly?'-50%':'10%',
        transform: 'translate(-50%, -50%)',
        zIndex: '999',
        overlay: 'auto',
        WebkitOverflowScrolling: 'touch',
        width: isMobileOnly?'100vw':"560px",
        height: isMobileOnly?'':"643px",
        borderRadius: '0px',
        backgroundColor: 'transparent',
        borderWidth: '0px',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '1000'
    },
};

const LoginPopup = ({ text, text2, text3, btn,
    onClosePopup }) => {
    return (
        <LoginPopupBlock>
            <SiLogin usePopUp={true} onClosePopup={onClosePopup}/>

        </LoginPopupBlock>
    );
};

export default LoginPopup;
